// extracted by mini-css-extract-plugin
export default {"wrapper":"ChallengesPage_wrapper__gLT3I"};